<template>
  <label for="check">
    <input
      type="checkbox"
      id="check"
      v-model="isChecked"
      @change="emitCheckboxState"
    />
    <span></span>
    <span></span>
    <span></span>
  </label>
</template>

<script>
export default {
  name: "XMenuIcon",
  data() {
    return {
      isChecked: false, // Tracks the checkbox state
    };
  },
  methods: {
    emitCheckboxState() {
      // Emit the checkbox state to the parent
      this.$emit("checkbox-changed", this.isChecked);
    },
  },
};
</script>

<style scoped>
/* Your existing styles remain unchanged */
label {
  display: flex;
  flex-direction: column;
  width: 35px;
  cursor: pointer;
}

label span {
  background: #777777;
  border-radius: 5px;
  height: 3.5px;
  margin: 3.5px 0;
  transition: 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
  box-shadow: 0 0 5px rgba(255, 255, 255, 0.844);
}

span:nth-of-type(1) {
  width: 50%;
}

span:nth-of-type(2) {
  width: 100%;
}

span:nth-of-type(3) {
  width: 75%;
}

input[type="checkbox"] {
  display: none;
}

input[type="checkbox"]:checked ~ span:nth-of-type(1) {
  transform-origin: bottom;
  transform: rotatez(45deg) translate(4px, 0px);
}

input[type="checkbox"]:checked ~ span:nth-of-type(2) {
  transform-origin: top;
  transform: rotatez(-45deg);
}

input[type="checkbox"]:checked ~ span:nth-of-type(3) {
  transform-origin: bottom;
  width: 50%;
  transform: translate(15px, -5.5px) rotatez(45deg);
}
</style>
